import { TefComs4p } from '@mfe/components/TefComs4p';
import { componentStateStore } from '@mfe/store';
import { Purpose } from '@mfec/types/model';
import { html } from 'lit';

//
// renders a single purpose block
//
// {Purpose name}
// {Purpose description}
//   {subscription BLOCK}
export const singlePurposeView = function render(this: TefComs4p, purpose : Purpose) : ReturnType<typeof html> {
  return html`
    <one-heading level="h6" variant="default">${purpose.title}</one-heading>
    <one-group position="apart" align-items="center" wrap="nowrap">
      <one-text as="p">${purpose.shortDescription} ${this.getTemplateFn('tefPurposeDescriptionModal')(purpose)}</one-text>
      <one-button variant="solid" size="medium" type="button" @click=${() => this.editPurpose(purpose.purposeId)} ?disabled=${componentStateStore.disabled}>Ändern</one-button>
    </one-group>
  `;
};
